import { bodyBgGradientAngle } from './BodyBgStore';

export const updateBodyBgGradientAngle = (value) => bodyBgGradientAngle.update(oldValue => value);
